import React, { useState, useEffect } from 'react';
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import { Link } from 'react-router-dom';
import Feature from "../components/feature/Feature";
import FooterOne from "../components/footer/FooterOne";

import Accordion from 'react-bootstrap/Accordion';



function OurService() {
    const breadcrumbs = [
        { label: 'Accueil', link: '/' },
        { label: 'À propos' }
    ];
    const [isVideoOpen, setIsVideoOpen] = useState(false);

    // Function to open the video overlay
    const openVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(true);
    };

    // Function to close the video overlay
    const closeVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(false);
    };

    // Effect to handle the escape key for closing the video overlay
    useEffect(() => {
        const handleKeyUp = (e) => {
            if (e.keyCode === 27) {
                setIsVideoOpen(false);
            }
        };

        // Add event listener for keyup
        document.addEventListener('keyup', handleKeyUp);

        // Cleanup function to remove event listener on component unmount
        return () => {
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return (
        <div className=''>

            <HeaderOne />
            <Breadcrumb title="À propos" breadcrumbs={breadcrumbs} />

            {/* Section valeurs et compétences */}
            <div className="rts-section-gap" style={{ background: '#f8f9fa' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center mb--50">
                            <p className="pre-title" style={{ fontSize: '18px', fontWeight: '600', color: '#5D666F', marginBottom: '15px' }}>Notre savoir-faire</p>
                            <h2 className="title" style={{ fontSize: '42px', fontWeight: '700', color: '#1C2539' }}>Ce qui nous distingue</h2>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-6 col-12">
                            <div style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px 30px',
                                textAlign: 'center',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div style={{ fontSize: '48px', marginBottom: '20px', color: 'var(--color-primary)' }}>✓</div>
                                <h5 style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', marginBottom: '15px' }}>Nos valeurs</h5>
                                <p style={{ fontSize: '15px', color: '#5D666F', lineHeight: '1.6' }}>
                                    Intégrité, transparence et engagement envers l'excellence
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px 30px',
                                textAlign: 'center',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div style={{ fontSize: '48px', marginBottom: '20px', color: 'var(--color-primary)' }}>⚖️</div>
                                <h5 style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', marginBottom: '15px' }}>Notre éthique</h5>
                                <p style={{ fontSize: '15px', color: '#5D666F', lineHeight: '1.6' }}>
                                    Respect des normes et des réglementations en vigueur
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px 30px',
                                textAlign: 'center',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div style={{ fontSize: '48px', marginBottom: '20px', color: 'var(--color-primary)' }}>🎯</div>
                                <h5 style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', marginBottom: '15px' }}>Nos compétences</h5>
                                <p style={{ fontSize: '15px', color: '#5D666F', lineHeight: '1.6' }}>
                                    Expertise technique et connaissance approfondie du terrain
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px 30px',
                                textAlign: 'center',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div style={{ fontSize: '48px', marginBottom: '20px', color: 'var(--color-primary)' }}>👥</div>
                                <h5 style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', marginBottom: '15px' }}>Notre équipe</h5>
                                <p style={{ fontSize: '15px', color: '#5D666F', lineHeight: '1.6' }}>
                                    Personnel expérimenté, rigoureux et qualifié
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* rts services area start */}
            <div className="rts-service-area rts-section-gapBottom">
                <div className="container-fluid service-main about-service-width-controler">
                    <div className="background-service service-three row">
                        <div className="row g-5">
                            <div className="rts-title-area service-four text-center pt--40 pt_md--0 mt_sm--0 mt_md--0">
                                <p className="pre-title">Nos Services</p>
                                <h2 className="title">Domaines d'activités</h2>
                            </div>
                            {/* start single Service */}
                            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pt--15 mb--80 mb_md--40 mb_sm--30">
                                <div className="service-one-inner-four">
                                    <div className="big-thumbnail-area">
                                        <Link to={'#'} className="thumbnail">
                                            <img
                                                src="assets/images/service/07.jpg"
                                                alt="Business-service"
                                            />
                                        </Link>
                                        <div className="content">
                                            <img
                                                src="assets/images/service/icon/13.svg"
                                                alt="Business-icon"
                                            />
                                            <h5 className="title">Prestation de services On/Off Shore</h5>
                                            <p className="disc">
                                                Externalisation d'activités pétrolières en mer et à terre pour optimiser votre fonctionnement
                                            </p>
                                        </div>
                                        <Link href="service-details.html" className="over_link" />
                                    </div>
                                    <Link to={'/service-2'} className="rts-btn btn-primary">
                                        {" "}
                                        En savoir plus
                                        <i className="fal fa-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                            {/* start single Service */}
                            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pt--15 mb--80 mb_md--40 mb_sm--30">
                                <div className="service-one-inner-four">
                                    <div className="big-thumbnail-area">
                                        <Link to={'#'} className="thumbnail">
                                            <img
                                                src="assets/images/service/08.jpg"
                                                alt="Business-service"
                                            />
                                        </Link>
                                        <div className="content">
                                            <img
                                                src="assets/images/service/icon/14.svg"
                                                alt="Business-icon"
                                            />
                                            <h5 className="title">Transit</h5>
                                            <p className="disc">
                                                Traçabilité permanente, respect des procédures internationales et coordination complète
                                            </p>
                                        </div>
                                        <Link href="service-details.html" className="over_link" />
                                    </div>
                                    <Link to={'/service-2'} className="rts-btn btn-primary">
                                        {" "}
                                        En savoir plus
                                        <i className="fal fa-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                            {/* start single Service */}
                            <div className="col-xl-4 col-md-6 col-sm-12 col-12 pt--15 mb--80">
                                <div className="service-one-inner-four">
                                    <div className="big-thumbnail-area">
                                        <Link to={'#'} className="thumbnail">
                                            <img
                                                src="assets/images/service/09.jpg"
                                                alt="Business-service"
                                            />
                                        </Link>
                                        <div className="content">
                                            <img
                                                src="assets/images/service/icon/15.svg"
                                                alt="Business-icon"
                                            />
                                            <h5 className="title">Construction BTP &amp; Génie civil</h5>
                                            <p className="disc">
                                                Construction, rénovation et aménagement avec engagement de qualité, fiabilité et respect des délais
                                            </p>
                                        </div>
                                        <Link href="service-details.html" className="over_link" />
                                    </div>
                                    <Link to={'/service-2'} className="rts-btn btn-primary">
                                        {" "}
                                        En savoir plus
                                        <i className="fal fa-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts services area End */}



            {/* rts faq section area */}
            <div className="rts-faq-section rts-section-gap rts-faq-bg bg_image">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="faq-two-inner">
                                <div className="title-area-faq">
                                    <span className="sub">POURQUOI NOUS CHOISIR</span>
                                    <h2 className="title">
                                        Nous sommes expérimentés
                                        <span className="sm-title">
                                            Solutions <span>professionnelles</span>
                                        </span>
                                    </h2>
                                </div>
                                {/* faq accordion area */}
                                <div className="faq-accordion-area">
                                    <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id="headingThree">
                                                <button
                                                    className="accordion-button collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseThree"
                                                    aria-expanded="false"
                                                    aria-controls="collapseThree"
                                                >

                                                </button>
                                            </h2>
                                            <div
                                                id="collapseThree"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingThree"
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="accordion-body">
                                                    Neque partrient nascetur facilisis suscipit ridiculus agna
                                                    lobortis imperdiet vivamus est aliquam euismod nector quam
                                                    convallis ornare justo service lifereu visionary sources
                                                    unleash online businesss solutions
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header><span>01. </span> Quels sont vos domaines d'activités ?</Accordion.Header>
                                            <Accordion.Body>
                                                Nous proposons des prestations de services On/Off Shore, transit, fourniture de matériaux de construction, construction BTP & Génie civil, fourniture d'équipements industriels, nettoyage industriel, fourniture d'équipement général, mise à disposition de personnel et transport & logistique.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header><span>02. </span> Où se trouve votre entreprise ?</Accordion.Header>
                                            <Accordion.Body>
                                                Notre direction générale est située à Pointe-Noire, capitale économique du Congo, à l'entrée du Port de Pointe-Noire, en diagonale de la Banque Postale du Port.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header><span>03. </span> Quels sont vos horaires d'ouverture ?</Accordion.Header>
                                            <Accordion.Body>
                                                Nous sommes ouverts du lundi au vendredi de 8h00 à 12h00 et de 13h00 à 17h00. Sur rendez-vous en dehors des heures et service d'astreinte 24h/24 pour nos clients.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                                {/* faq accordion area end */}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="thumbnail-faq-four">
                                <img src="assets/images/faq/02.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts faq section area End */}


            {/* Informations légales */}
            <div className="rts-section-gap" style={{ background: '#fff' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center mb--50">
                            <p className="pre-title" style={{ fontSize: '18px', fontWeight: '600', color: '#5D666F', marginBottom: '15px' }}>Informations légales</p>
                            <h2 className="title" style={{ fontSize: '42px', fontWeight: '700', color: '#1C2539' }}>Données de l'entreprise</h2>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div style={{ 
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                                borderRadius: '15px', 
                                padding: '35px',
                                color: '#fff',
                                boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)'
                            }}>
                                <h5 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '20px', opacity: 0.9 }}>Identité</h5>
                                <p style={{ fontSize: '14px', marginBottom: '8px', opacity: 0.9 }}>Raison sociale</p>
                                <p style={{ fontSize: '18px', fontWeight: '700', marginBottom: '20px' }}>GLOBAL-SERVICES CONGO SARLU</p>
                                <p style={{ fontSize: '14px', marginBottom: '8px', opacity: 0.9 }}>Sigle</p>
                                <p style={{ fontSize: '18px', fontWeight: '700', marginBottom: '20px' }}>GSC Sarlu</p>
                                <p style={{ fontSize: '14px', marginBottom: '8px', opacity: 0.9 }}>Capital</p>
                                <p style={{ fontSize: '18px', fontWeight: '700' }}>1.000.000 FCFA</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div style={{ 
                                background: '#f8f9fa', 
                                borderRadius: '15px', 
                                padding: '35px',
                                border: '2px solid #e9ecef',
                                height: '100%'
                            }}>
                                <h5 style={{ fontSize: '18px', fontWeight: '700', color: '#1C2539', marginBottom: '20px' }}>Numéros d'identification</h5>
                                <div style={{ marginBottom: '20px' }}>
                                    <p style={{ fontSize: '14px', color: '#5D666F', marginBottom: '8px', fontWeight: '600' }}>NIU</p>
                                    <p style={{ fontSize: '16px', color: '#1C2539', fontWeight: '600' }}>M222000000210682F</p>
                                </div>
                                <div>
                                    <p style={{ fontSize: '14px', color: '#5D666F', marginBottom: '8px', fontWeight: '600' }}>RCCM</p>
                                    <p style={{ fontSize: '16px', color: '#1C2539', fontWeight: '600' }}>CG-PNR-01-2022-B12-00086</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div style={{ 
                                background: '#f8f9fa', 
                                borderRadius: '15px', 
                                padding: '35px',
                                border: '2px solid #e9ecef',
                                height: '100%'
                            }}>
                                <h5 style={{ fontSize: '18px', fontWeight: '700', color: '#1C2539', marginBottom: '20px' }}>Comptes bancaires</h5>
                                <div style={{ marginBottom: '15px' }}>
                                    <p style={{ fontSize: '14px', color: '#5D666F', marginBottom: '5px', fontWeight: '600' }}>ECOBANK</p>
                                    <p style={{ fontSize: '16px', color: '#1C2539', fontWeight: '600' }}>37285010191</p>
                                </div>
                                <div style={{ marginBottom: '15px' }}>
                                    <p style={{ fontSize: '14px', color: '#5D666F', marginBottom: '5px', fontWeight: '600' }}>MUCODEC</p>
                                    <p style={{ fontSize: '16px', color: '#1C2539', fontWeight: '600' }}>00000036688</p>
                                </div>
                                <div>
                                    <p style={{ fontSize: '14px', color: '#5D666F', marginBottom: '5px', fontWeight: '600' }}>CAPPED</p>
                                    <p style={{ fontSize: '16px', color: '#1C2539', fontWeight: '600' }}>CO608258</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* customers feed back area start */}
            <div className="rts-customer-feedback-area rts-section-gap bg-customer-feedback" style={{ background: '#f8f9fa' }}>
                <div className="container">
                    <div className="row">
                        <div className="rts-title-area feedback team text-center">
                            <p className="pre-title" style={{ fontSize: '18px', fontWeight: '600', color: '#5D666F', marginBottom: '15px' }}>Témoignages</p>
                            <h2 className="title" style={{ fontSize: '42px', fontWeight: '700', color: '#1C2539' }}>Ce que disent nos clients</h2>
                        </div>
                    </div>
                    <div className="row g-5 mt--20">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="testimopnial-wrapper-two" style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div className="test-header" style={{ marginBottom: '25px' }}>
                                    <div className="thumbnail" style={{ marginRight: '20px' }}>
                                        <img src="assets/images/testimonials/02.png" alt="" style={{ width: '70px', height: '70px', borderRadius: '50%', objectFit: 'cover' }} />
                                    </div>
                                    <div className="name-desig">
                                        <h5 className="title" style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', marginBottom: '5px' }}>Partenaire Eiffage</h5>
                                        <span className="designation" style={{ fontSize: '14px', color: '#5D666F' }}>Client professionnel</span>
                                    </div>
                                </div>
                                <div className="test-body">
                                    <p className="disc" style={{ fontSize: '16px', lineHeight: '1.8', color: '#5D666F', fontStyle: 'italic' }}>
                                        "Une équipe réactive et compétente qui comprend nos besoins et propose des solutions adaptées. Leur service de transit et de logistique est excellent."
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="testimopnial-wrapper-two" style={{ 
                                background: '#fff', 
                                borderRadius: '15px', 
                                padding: '40px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.12)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                            }}>
                                <div className="test-header" style={{ marginBottom: '25px' }}>
                                    <div className="thumbnail" style={{ marginRight: '20px' }}>
                                        <img src="assets/images/testimonials/03.png" alt="" style={{ width: '70px', height: '70px', borderRadius: '50%', objectFit: 'cover' }} />
                                    </div>
                                    <div className="name-desig">
                                        <h5 className="title" style={{ fontSize: '20px', fontWeight: '700', color: '#1C2539', marginBottom: '5px' }}>SNPC</h5>
                                        <span className="designation" style={{ fontSize: '14px', color: '#5D666F' }}>Partenaire stratégique</span>
                                    </div>
                                </div>
                                <div className="test-body">
                                    <p className="disc" style={{ fontSize: '16px', lineHeight: '1.8', color: '#5D666F', fontStyle: 'italic' }}>
                                        "GSC Sarlu est un partenaire fiable pour nos activités pétrolières. Leur expertise en prestations On/Off Shore et leur professionnalisme font d'eux un partenaire de choix."
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* customers feed back area end */}


            <FooterOne />

        </div>
    )
}

export default OurService